import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { authHeaders } from './auth';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const DEFAULT_CONFIG = {
  max_cars_per_villa: 3,
  max_bikes_per_villa: 1,
  vehicle_approval_required: true,
  anpr_enabled: true,
  facility_booking_enabled: true,
  booking_approval_required: true,
  invoicing_enabled: false,
  payments_enabled: false,
  receipts_enabled: false,
  notice_email_enabled: true,
  welcome_email_enabled: true,
  max_residents: 500,
  max_guards: 3,
  max_facilities: 10,
  gate_pass_enabled: true,
  max_gate_pass_hours: 24,
  mc_list_enabled: false,
  neighbors_directory_enabled: false,
};

const CommunityConfigContext = createContext({ config: DEFAULT_CONFIG, loading: true });

export function CommunityConfigProvider({ children }) {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await fetch(`${API_URL}/api/community/config`, { headers: authHeaders() });
        if (res.ok) {
          const data = await res.json();
          setConfig({ ...DEFAULT_CONFIG, ...data.config });
        }
      } catch (err) {
        process.env.NODE_ENV !== 'production' && console.error('Failed to load community config:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchConfig();
  }, []);

  const value = useMemo(() => ({ config, loading }), [config, loading]);

  return (
    <CommunityConfigContext.Provider value={value}>
      {children}
    </CommunityConfigContext.Provider>
  );
}

export function useCommunityConfig() {
  return useContext(CommunityConfigContext);
}
